export default {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'stopEditingController',
    template: require('../views/stopEditing.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/stopEditing.component.js